import { useSelector } from 'react-redux'
import { selectFilterModel, selectFilterOptions, selectSortItem } from 'state/review'
import {
    selectIndividualPerformanceFilterModel,
    selectIndividualPerformanceFilterOptions,
    selectIndividualPerformanceSortItem,
} from 'state/campaignReport'
import { TableViewType } from '.'
import { selectIndividualPerformanceFilters, selectSubmissionFilters, selectAmbassadorFilters } from 'state/filter'
import {
    selectFilterModel as selectAmbassadorFilterModel,
    selectFilterOptions as selectAmbassadorFilterOptions,
    selectSortItem as selectAmbassadorSortItem,
} from 'state/ambassadors'

export const useFilterOptions = (viewType?: TableViewType) => {
    const reviewFilterOptions = useSelector(selectFilterOptions)
    const individualPerformanceFilterOptions = useSelector(selectIndividualPerformanceFilterOptions)
    const ambassadorFilterOptions = useSelector(selectAmbassadorFilterOptions)

    if (viewType === TableViewType.AMBASSADOR) {
        return ambassadorFilterOptions
    }

    if (viewType === TableViewType.INDIVIDUAL_PERFORMANCE) {
        return individualPerformanceFilterOptions
    }

    return reviewFilterOptions
}

export const useFilterModel = (viewType?: TableViewType) => {
    const reviewFilterModel = useSelector(selectFilterModel)
    const ambassadorFilterModel = useSelector(selectAmbassadorFilterModel)
    const individualPerformanceFilterModel = useSelector(selectIndividualPerformanceFilterModel)

    if (viewType === TableViewType.INDIVIDUAL_PERFORMANCE) {
        return individualPerformanceFilterModel
    }

    if (viewType === TableViewType.AMBASSADOR) {
        return ambassadorFilterModel
    }

    return reviewFilterModel
}

export const useSortItem = (viewType?: TableViewType) => {
    const reviewSortItem = useSelector(selectSortItem)
    const ambassadorSortItem = useSelector(selectAmbassadorSortItem)
    const individualPerformanceSortItem = useSelector(selectIndividualPerformanceSortItem)

    if (viewType === TableViewType.INDIVIDUAL_PERFORMANCE) {
        return individualPerformanceSortItem
    }

    if (viewType === TableViewType.AMBASSADOR) {
        return ambassadorSortItem
    }

    return reviewSortItem
}

export const useActiveFilter = (viewType?: TableViewType) => {
    const registrationFilters = useSelector(selectSubmissionFilters)
    const ambassadorFilters = useSelector(selectAmbassadorFilters)
    const individualPerformanceFilters = useSelector(selectIndividualPerformanceFilters)

    if (viewType === TableViewType.INDIVIDUAL_PERFORMANCE) {
        return individualPerformanceFilters
    }

    if (viewType === TableViewType.AMBASSADOR) {
        return ambassadorFilters
    }

    return registrationFilters
}
